import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "routes/AuthContext";

interface ProtectedRouteProps {
  children: ReactNode;
  allowedRoles: string[];
}

const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();

  if(allowedRoles.length === 0) return <>{children}</>;

  if (loading) return <div></div>; 

  if(!user) return <Navigate to="/" />;

  if (user && !allowedRoles.includes(user.role || "")) {
    return <Navigate to="/unauthorized" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
